import { formatDate, momentWithTimezone } from '@/utils/date';

/** "08/03/26" in the viewer's timezone. Empty for rows with no bookmark. */
export const formatBookmarkedDate = (bookmarkedAt: string | null): string =>
  bookmarkedAt
    ? (formatDate(momentWithTimezone(bookmarkedAt), {
        day: '2-digit',
        month: '2-digit',
        year: '2-digit',
      }) ?? '')
    : '';

/**
 * Sort key for the Bookmarked date column. A variant-pack row isn't bookmarked
 * itself, so it sorts by its most recently bookmarked account; rows with no
 * bookmark at all sort first (ascending) / last (descending) at 0.
 */
export const latestBookmarkedAt = (
  bookmarkedAtValues: (string | null)[],
): number => {
  const timestamps = bookmarkedAtValues
    .filter((value): value is string => Boolean(value))
    .map((value) => new Date(value).getTime())
    .filter((timestamp) => !isNaN(timestamp));

  return timestamps.length > 0 ? Math.max(...timestamps) : 0;
};
